"use strict";

exports.__esModule = true;
exports.default = create;
var _baseCreate = _interopRequireDefault(require("./_baseCreate.js"));
var _extendOwn = _interopRequireDefault(require("./extendOwn.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = (0, _baseCreate.default)(prototype);
  if (props) (0, _extendOwn.default)(result, props);
  return result;
}